const UrlInfo = require('../../olycommon/urlinfo/url-info');

module.exports = function (analyticsService) {
    function SocialButtonsController() {
        // ---------- for demo, don't forget to delete
        // this.url = 'https://www.woolworths.com.au/Shop/Recipes/christmas/jamie-olivers-christmas-recipes?name=jamie-s-baked-peach-apricot-pav-with-pistachios-honey&recipeId=4080';
        // this.media = 'https://www.woolworths.com.au/Content/wowRecipeImages/Large/1512-Jamie-BakedPeachApricotPavWithHoneyPistachios.jpg';
        // this.description = "Jamie's Baked Peach & Apricot Pav With Pistachios & Honey";
        // ---------- for demo, don't forget to delete
        const urlInfo = new UrlInfo(this.url);
        const mediaInfo = new UrlInfo(this.media);
        this.encodedUrl = encodeURIComponent(urlInfo.href());
        this.encodedMedia = encodeURIComponent(mediaInfo.href());
        this.encodedDescription = encodeURIComponent(this.description);

        this.facebookShareClick = () => {
            analyticsService.pushEvent(analyticsService.eventsDtm.SOCIAL_SHARE.FACEBOOK);
        };
        this.twitterShareClick = () => {
            analyticsService.pushEvent(analyticsService.eventsDtm.SOCIAL_SHARE.TWITTER);
        };
        this.googlePlusShareClick = () => {
            analyticsService.pushEvent(analyticsService.eventsDtm.SOCIAL_SHARE.GOOGLEPLUS);
        };
        this.pinterestShareClick = () => {
            analyticsService.pushEvent(analyticsService.eventsDtm.SOCIAL_SHARE.PINTEREST);
        };
    }

    return {
        restrict: 'E',
        scope: {
            url: '=',
            media: '=',
            description: '=',
        },
        bindToController: true,
        controllerAs: 'ctrl',
        controller: [SocialButtonsController],
        template: require('./social-buttons.directive.html').trim(),
    };
};



// WEBPACK FOOTER //
// ./src/common/socialmedia/social-buttons.directive.js